import { useUser } from '../../redux/user/useUser';
import { ContactLink } from './ContactLink';
import { UserRole } from '../../gen/graphql';
import styled from 'styled-components';
import { ContactType } from './ContactLink';

export const FeedbackNotice = (): JSX.Element => {
  const role = useUser().user.role;
  const contactType = getContactType(role);

  if (contactType === 'other') {
    return (
      <AlertText>
        こちらのフォームでは個別の返信はしておりません。送信の際は記入内容をご確認の上、下のチェックボックスを選択後に送信してください。
      </AlertText>
    );
  }

  return (
    <AlertText>
      こちらのフォームでは個別の返信はしておりません。返信が必要な場合は、
      <ContactLink contactType={contactType} />
      からお問い合わせください。送信の際は記入内容をご確認の上、下のチェックボックスを選択後に送信してください。
    </AlertText>
  );
};

const getContactType = (role: UserRole): ContactType | 'other' => {
  const subscriptionRoles: readonly UserRole[] = [
    UserRole.NotLogin,
    UserRole.Subscription,
    UserRole.SubscriptionLight,
    UserRole.SubscriptionBasic,
    UserRole.SubscriptionPremium,
    UserRole.SubscriptionFree,
    UserRole.TeamMember,
    UserRole.TeamMemberFree,
    UserRole.TeamAdmin,
    UserRole.TeamAdminFree,
  ];

  if (subscriptionRoles.includes(role)) {
    return 'subscription';
  }

  const studentRoles: readonly UserRole[] = [
    UserRole.Student,
    UserRole.StudentGraduated,
    UserRole.StudentSubscription,
    UserRole.StudentSubscriptionLight,
    UserRole.StudentSubscriptionBasic,
    UserRole.StudentSubscriptionPremium,
    UserRole.StudentFree,
  ];

  if (studentRoles.includes(role)) {
    return 'student';
  }

  return 'other';
};

const AlertText = styled.p`
  font-size: 0.75rem;
  line-height: 1.125rem;
  a {
    font-size: inherit;
    color: #e2001b;
  }
`;
